module.exports = __webpack_public_path__ + "static/media/pointer-up.d3b5c8a0.svg";